import {observable, action, computed} from "mobx"
import axios from "axios"

class AppStore{
  @observable rdv = {}
  @observable bien = {}
  @observable ordremission={}
  @observable cexpert_saved = false

  @computed get loaded(){
    if(this.rdv=={}){
      return false
    }else{
      return true
    }
  }
  @computed get cexpert_valid(){
    let nom = this.ordremission.cexpert_nom || ""
    let prenom = this.ordremission.cexpert_prenom || ""
    let adr = this.ordremission.cexpert_adress|| ""
    if(nom.length>1 && prenom.length > 1 && adr.length > 1 ){
      return(true)
    }else{
      return(false)
    }
  }
  @action contreExpertPresence(that){
    var status = !this.ordremission.contreexpert
    axios.post("/api/v1/experts/app/ordremission/updatePresenceContreExpert",{id: this.rdv.id,contreexpert: status})
    this.ordremission.contreexpert = status
    that.calculateState()
  }
  @action validateContreExpert(){
    var that = this
    axios.post("/api/v1/experts/app/ordremission/updateContreExpert",{id: this.rdv.id,cexpert: {
      cexpert_prenom: this.ordremission.cexpert_prenom,
      cexpert_nom: this.ordremission.cexpert_nom,
      cexpert_adress: this.ordremission.cexpert_adress}}).then((data)=>{
        that.cexpert_saved = true
      })
  }

}

let store = new AppStore()
global.AppStore = store
export default store
